
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { updatePIDiscountAndProfit } from "@/api/proforma";
import { deepClone } from "@/utils/deepClone";
@Component({
  name: "ModifyDiscounts",
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: false }) private isEdit: boolean;
  @Prop({ default: [] }) private selectedList: [];
  @Prop({ default: "" }) private inquirySheetId: "";
  @Prop({ default: "修改折算利润率" }) private title: "";
  private form = {
    saleDiscount: null,
    purchaseDiscount: null,
  };
  private newSelectedRows: any[] = [];

  @Watch("selectedList", { immediate: true })
  private async watchData() {
    this.newSelectedRows = deepClone(this.selectedList);
    // console.log(this.newSelectedRows)
  }
  private list = [
    {
      label: "折算利润率",
      prop: "conversionMarginProfit",
      key: "conversionMarginProfit",
      type: "input",
      placeholder: "请输入折算利润率",
      clearable: true,
      maxlength: 10,
      unit: "%",
      rules: {
        required: true,
        message: "请输入折算利润率",
        trigger: "change",
      },
    },
  ];
  private close() {
    this.$emit("update:show", false);
  }
  private open() {
    this.$emit("update:show", true);
  }
  private async submitForm(): Promise<void> {
    (this.$refs.ruleForm as any).$refs.ruleForm.validate(
      async (valid: boolean) => {
        if (valid) {
          try {
            this.updateDraftDiscount(this.form);
          } catch (error) {
            console.error(error);
          }
        }
      }
    );
  }
  private async updateDraftDiscount(form: any) {
    if (!this.newSelectedRows.length) {
      this.$notify({
        title: "提示",
        message: "请选择产品",
        type: "error",
        duration: 2000,
      });
      return;
    }
    const proformaInvoiceInfoIds = this.newSelectedRows.map((item) => item.id);
    const { conversionMarginProfit } = form;
    let params = {
      proformaInvoiceInfoIds,
      conversionMarginProfit: `${conversionMarginProfit}%`,
    };
    try {
      await updatePIDiscountAndProfit(params);
      this.$notify({
        title: "提示",
        message: "修改成功",
        type: "success",
        duration: 2000,
      });
      this.close();
      this.$emit("success", false);
    } catch {}
  }
}
